export default __webpack_public_path__ + "locales/zh-CN/FilesSettings.json?hash=2e8195835f7a2482ea4577b15bb4f72a";